import { useEffect, useState } from "react";
import SidebarUpdate from "../components/SidebarUpdate";

import { ClipLoader } from "react-spinners";
import apiInstance from "../apiConfig/apiinstance";

const Home = () => {
  const [category, setCategory] = useState([]);
  const [error, setError] = useState("");
  const [image, setImage] = useState("");
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const getData = async () => {
    setLoading(true);
    try {
      const { data } = await apiInstance.get(`/api/cat/v1/categories/`);

      if (data.status === 200) {
        if (data?.data?.length === 0) {
          // setError("No categories found");
          return;
        }
        setCategory(data?.data);
      }
    } catch (error) {
      setError(error?.response?.data?.message);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const getDataCoverImage = async () => {
    setLoading(true);
    try {
      const { data } = await apiInstance.get(
        `/api/landing/v1/get-landing-page/`
      );
      if (data.status === 200) {
        setImage(data.data.data);
      }
    } catch (error) {
      setError(error?.response?.data?.message);
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  console.log("category data", category);

  useEffect(() => {
    getData();
    getDataCoverImage();
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const token = localStorage.getItem("token");

  return (
    <div>
      {loading ? (
        <div className="loader-container">
          <ClipLoader color="#3498db" loading={loading} size={50} />
        </div>
      ) : error ? (
        <h2
          style={{
            color: "red",
            textAlign: "center",
            height: "80vh",
            marginTop: "2em",
          }}
        >
          {error}
        </h2>
      ) : (
        <div className="content_wrapper">
          {token && <SidebarUpdate />}

          <div
            className={`home_container ${token ? "" : "ml-0"}`}
            // style={{
            //   marginLeft:  ? "0rem" : "0",
            // }}
          >
            {isMobile ? (
              <img src={image.is_for_mobile} alt="portrait" />
            ) : (
              <img src={image.is_for_desktop} alt="Landscape" />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
